import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import JobSection from "./JobSection";

const JobMain = ({ jobs }) => {
  return (
    <main>
      <Breadcrumb title="Jobs" />
      <JobSection jobs={jobs}/>
    </main>
  );
};
export default JobMain;
